<template>
  <v-container fluid>
    <v-row>
      <v-col>
        <loading-spinner v-if="isLoading"></loading-spinner>
        <v-card v-else>
          <card-header
            :title="$t('title.create_consent_document')"
            icon="menu"
            color="primary"
            variant="gradient"
          ></card-header>

          <v-form ref="form" v-model="valid">
            <v-card-text>
              <v-row>
                <v-col cols="12" sm="6">
                  <v-text-field
                    v-model="consentDocument.title"
                    :label="$t('label.consent_document_title')"
                    :rules="requiredRules"
                    required
                  ></v-text-field>
                </v-col>

                <v-col cols="12" sm="6">
                  <v-select
                    v-model="consentDocument.consent_document_type_idx"
                    :label="$t('label.consent_document_category')"
                    :items="consentDocumentTypes"
                    :item-value="(item) => item.idx"
                    :item-text="(item) => item.name"
                    :rules="requiredRules"
                    required
                  ></v-select>
                </v-col>
              </v-row>

              <v-row>
                <v-col cols="12">
                  <v-textarea
                    v-model="consentDocument.content"
                    :label="$t('label.consent_document_content')"
                    outlined
                    dense
                    :rules="requiredRules"
                    required
                  ></v-textarea>
                </v-col>
              </v-row>

              <v-card-actions>
                <custom-button
                  :label="$t('button.close')"
                  color="black"
                  size="lg"
                  gradient
                  rounded
                  @click="toConsentDocumentList"
                ></custom-button>
                <v-spacer></v-spacer>
                <custom-button
                  :label="$t('button.save')"
                  :disabled="!valid"
                  color="primary"
                  size="lg"
                  gradient
                  rounded
                  @click="submit"
                ></custom-button>
              </v-card-actions>
            </v-card-text>
          </v-form>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import CardHeader from "@/components/cards/CardHeader.vue";
import CustomButton from "@/components/common/buttons/CustomButton.vue";
import LoadingSpinner from "@/components/common/Spinners/LoadingSpinner.vue";

import { confirmClosePopup, confirmSavePopup } from "@/fields/journal/popups";
import { consentDocumentTypeApi, consentDocumentApi } from "@/api/api";

export default {
  name: "CreateConsentDocument",
  components: {
    CardHeader,
    CustomButton,
    LoadingSpinner,
  },
  data() {
    return {
      consentDocument: {
        title: "",
        consent_document_type_idx: null,
        content: "",
      },
      consentDocumentTypes: [],
      valid: false,
      isLoading: false,
    };
  },
  computed: {
    requiredRules() {
      return [(v) => !!v || this.$t("valid.required_field")];
    },
  },
  methods: {
    /* ****************************************************************************************
     * 이벤트 핸들러
     * ****************************************************************************************/
    // TODO: 알럿 추가
    toConsentDocumentList() {
      this.$router.push(`/journals/consent-documents/management`);
    },
    async cancel() {
      const isConfirm = await confirmClosePopup();

      if (isConfirm) {
        this.toConsentDocumentList();
      }
    },

    async submit() {
      const isConfirm = await confirmSavePopup();

      if (isConfirm) {
        await this.createConsentDocument();
        await this.toConsentDocumentList();
      }
    },

    /* ****************************************************************************************
     * API 호출
     * ****************************************************************************************/
    async fetchConsentDocumentTypes() {
      this.isLoading = true;

      try {
        const response = await consentDocumentTypeApi.showAll();

        if (response.status === 200) {
          this.consentDocumentTypes = response.data.response;
        }
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error(error);
        this.notifyVue({
          message: this.$t("alert.failed_request"),
          style: "danger",
        });
      }

      this.isLoading = false;
    },

    async createConsentDocument() {
      this.isLoading = true;

      const data = {
        title: this.consentDocument.title,
        consent_document_type_idx:
          this.consentDocument.consent_document_type_idx,
        content: this.consentDocument.content,
      };

      try {
        const response = await consentDocumentApi.createConsentDocument(data);

        if (response.status === 201) {
          this.notifyVue({
            message: this.$t("alert.success_create_consent_document"),
            style: "success",
          });
        }
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error(error);
        this.notifyVue({
          message: this.$t("alert.failed_create_consent_document"),
          style: "danger",
        });
      } finally {
        this.isLoading = false;
      }
    },

    /* ****************************************************************************************
     * 알럿
     * ****************************************************************************************/
    notifyVue({
      vertical = "top",
      horizontal = "right",
      message = "",
      style = "primary",
      icon = "priority_high",
    } = {}) {
      this.$notify({
        timeout: 8000,
        message: message,
        icon: icon,
        type: style,
        horizontalAlign: horizontal,
        verticalAlign: vertical,
      });
    },
  },
  mounted() {
    this.fetchConsentDocumentTypes();
  },
};
</script>
